import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageHeader from '../../layouts/page-header/PageHeader';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getAllBranches, getBranchList } from '../../store/actions';
import { useTranslation } from 'react-i18next';
import Pagination from '../../component/pagination';
import { useParams } from 'react-router-dom';
import BlogSidebar from './sidebar';
import './style.scss'
import { base } from '../../store/api';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function BlogClassic(props) {
  const { t } = useTranslation()

  return (
    <Link to={{ pathname: `/branch-details/${props.id}` }} className={`${props.is_active === false && 'inactive-link'}`}>
      <article

        className="tw-rounded tw-transition-shadow tw-duration-300 tw-shadow hover:tw-shadow-md tw-p-4 tw-flex tw-flex-col md:tw-flex-row tw-gap-2.5 tw-group"
        // className={`blog-post relative blog-classic d-flex align-items-center gap-4 ${props.postType || ''}`}
        // style={{ padding: '0 15px', boxShadow: '0 0 40px hsla(0,0%,51%,.1), 0 0 40px hsla(0,0%,51%,.1)' }}
      >

        <div className="tw-relative tw-w-full md:tw-basis-1/2 tw-aspect-[3/2]">
          <img
            className="tw-w-full tw-aspect-[3/2] tw-object-cover tw-object-center"
            src={props.imgSrc}
            alt={props.title}
            width={600} height={400}
          />
          <div className="tw-text-white tw-h-full tw-absolute tw-top-0 -tw-right-1">

            <svg className="tw-h-full" viewBox="0 0 20 104" fill="currentColor">
              <polygon points="17.3036738 5.68434189e-14 20 5.68434189e-14 20 104 0.824555778 104"/>
            </svg>
          </div>
        </div>

        <div className="tw-basis-1/2 tw-p-4 tw-flex tw-flex-col tw-justify-between tw-gap-4">
          <h4 className="entry-title ">
            <Link className="tw-text-black group-hover:tw-text-primary" to={{ pathname:`/branch-details/${props.id}`}}>
              {props.title}
            </Link>
          </h4>
          {
            props.is_active ?

              <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-1 tw-text-primary" >
                {t("see")} <i className='fas fa-chevron-right tw-transition-transform tw-duration-300 group-hover:tw-translate-x-1'/></div> :
              <div  style={{ backgroundColor: '#2467ec', color: 'white', borderRadius: '6px', padding: '2px 10px', width: 'fit-content' }}>{t("soon")}</div>
          }

        </div>
      </article>
    </Link>
  );
}

function Branch() {
  const dispatch = useDispatch()
  const [news, setNews] = useState([])
  const { t } = useTranslation()
  const language = localStorage.getItem('i18nextLng')

  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { categoryId } = useParams()
  const location = useLocation()
  // const [categories, setCategories] = useState([])
  // const [title, setTitle] = useState('')

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [language, categoryId, currentPage])

  useEffect(() => {
    const lang = language === 'tm' ? 'tk' : language
    let params = {
      limit: 20,
      offset: (currentPage - 1) * 20,
      category_id: categoryId
    }
    location.pathname === '/branches/all' ?
      getAllBranches(dispatch, params, lang, (err, res) => {
        if (err) console.log(err);
        setNews(res?.results)
        setCount(res?.count)

      })
      :
      getBranchList(dispatch, params, lang, (err, res) => {
        if (err) console.log(err);
        setNews(res?.results)
        setCount(res?.count)

      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, categoryId, currentPage])

  return (
    <>
      <Helmet>
        <title>{`${t("branches")} - ${t("iicimet")} ${t("iicimet_short")}`}</title>
        <meta name="description" content="Lorem ipsum dolor sit amet" />
      </Helmet>
      <div className="site-content">
        <PageHeader
          title={t("branches")}
          PagaHeaderBg={'/images/bg.svg'}
          breadCrumbItems={[
            { label: t("home"), path: '/' }
          ]}
        />
        <div className="content-wrapper page-template">
          <Container>
            <Row className="justify-content-center row-reverse">
              <Col xl={8} lg={12} md={12}>
                <div className="blog-wrapper grid-wrapper grid-lg-1 grid-md-1 grid-sm-1 grid-xs-1">
                  {news.length ? news.map((val, ind) => {
                    return (
                      <BlogClassic
                        key={ind}
                        id={val.id}
                        imgSrc={`${base}${val.thumbnail}`}
                        date={val.date_added}
                        title={val.title}
                        is_active={val.is_active}
                        description={val.description}
                      />
                    );
                  }) : ''}
                </div>
              </Col>
              <Col xl={4} lg={12} md={12}>
                <BlogSidebar id={categoryId} />
              </Col>
            </Row>

            <Pagination currentPage={currentPage} count={count} handlePageChange={(e) => handlePageChange(e)} />
          </Container>
        </div>
      </div>
    </>
  );
}

export default Branch;
